<template>
  <div id="htsz">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
export default {
  name: 'htsz'
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/contract/set/Set.vue